import { useEffect, useState } from "react";
import { Compass } from "lucide-react";
import { getCascade } from "@/lib/api";

// §22 — CASCADE ORIENTATION. Repurposes the "You're working on" panel to show the CURRENT FOCAL PROCESS
// (and, lightly, what's been worked out + what comes next) from the read-only cascade coordinator. No
// percentages / gamification. Renders nothing until it has data, so it never breaks layout or the demo.
export const CascadeOrientation = ({ sessionId, refreshKey, view = "", className = "", onStepBack = null }) => {
  const [c, setC] = useState(null);
  useEffect(() => {
    let alive = true;
    if (!sessionId) return undefined;
    getCascade(sessionId, view)
      .then((d) => { if (alive) setC(d); })
      .catch(() => {});
    return () => { alive = false; };
  }, [sessionId, refreshKey, view]);

  if (!c || !c.orientation || !c.orientation.working_on) return null;
  const o = c.orientation;
  const ret = c.return_target;
  return (
    <div data-testid="cascade-orientation" className={`rounded-md border border-stone-200 bg-white/70 px-4 py-3 ${className}`}>
      <p className="font-mono-panel text-[10px] uppercase tracking-[0.18em] text-stone-400 mb-1 flex items-center gap-1.5">
        <Compass className="h-3 w-3" /> You&rsquo;re working on
      </p>
      <p className="text-[15px] font-serif-display text-stone-900 leading-snug" data-testid="cascade-working-on">{o.working_on}</p>
      {o.worked_out ? (
        <p className="text-[12px] text-stone-500 mt-1.5" data-testid="cascade-worked-out">{o.worked_out}</p>
      ) : null}
      {o.comes_next ? (
        <p className="text-[12px] text-stone-500 mt-0.5" data-testid="cascade-comes-next">
          <span className="text-stone-400">Next:</span> {o.comes_next}
        </p>
      ) : null}
      {ret && ret.stage ? (
        <div className="mt-2 border-t border-stone-200/70 pt-2" data-testid="cascade-return-target">
          <p className="text-[12px] text-amber-700">
            <span className="font-semibold">Worth a step back:</span> {ret.diagnosis || ret.reason}
          </p>
          {onStepBack ? (
            <button
              data-testid="cascade-step-back-btn"
              onClick={() => onStepBack(ret)}
              className="mt-1.5 inline-flex items-center gap-1 text-[12px] font-medium text-amber-800 border border-amber-300 rounded-full px-3 py-1 hover:bg-amber-50 transition-colors">
              Step back to work on this
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default CascadeOrientation;
